<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Edit Domain
          <v-btn icon @click="$router.push('/domains')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <v-form v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Domain</label></v-col
              >
              <v-col sm="8">
                <v-text-field v-model="domainName" :rules="nameRules" filled />
                <font color="red" class="v-virtual-table">{{ text }}</font>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center mt-8">
                <v-btn
                  :disabled="!valid || buttonCheck() || isDuplicate"
                  class="primary_btn small"
                  depressed
                  @click="updateDomainById"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { storeActions } from '@/store/actions.constants';
import { mapActions } from 'vuex';
export default {
  data: () => ({
    valid: false,
    domainName: null,
    isDuplicate: false,
    text: '',
    nameRules: [
      (v) => !!v || 'Domain is Required',
      (v) =>
        /^[a-zA-Z][a-zA-Z0-9\s]{2,19}$/.test(v) ||
        'Special characters and Initial numbers are not allowed and string length must be between 3 to 20.',
    ],
  }),
  // computed: {
  //     name() {
  //         return this.data
  //     }
  // },
  async mounted() {
    let id = this.$route.params.id;
    await this.getDomainById(id);
  },
  methods: {
    ...mapActions({
      updateDomain: 'domains/updateDomainById',
      getDomain: 'domains/getDomainById',
    }),
    getDomainById(id) {
      let domainObj = {
        id: id,
      };
      this.getDomain(domainObj)
        .then((res) => {
          console.log(res);
          this.domainName = res.data.name;
          this.editId = res.data.id;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          // Skip login until API and schema got finalise
          this.text = err.message;
          console.error(err);
        });
    },
    updateDomainById() {
      const domainObj = {
        id: this.editId,
        name: this.domainName,
      };
      this.updateDomain(domainObj).then((res) => {
        if (res.status === 200) {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: res.data.message,
            timeout: 1000,
            color: 'success',
          });
          this.$router.push('/domains');
        } else {
          this.text = res.data.message;
        }
      });
    },
    buttonCheck() {
      // var check = (val) => val.check === false;
      if (this.domainName == null) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
